// @ts-check
import React, { Component } from 'react';
import { reduxForm } from 'utils/reduxFormWrapper';
import HForm, { CheckboxGroupField } from 'shared/containers/portal_layout/HForm';
import actions from './actions';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import Errors from 'shared/components/Errors';
import LoadingContent from 'shared/components/LoadingContent';
import SpinnerButton from 'shared/components/SpinnerButton';

class NotificationPreferences extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { checkedPreferences: null, preferences: null };
    this.savePreferences = this.savePreferences.bind(this);
  }

  componentDidMount() {
    return actions.fetchPreferences().then(data =>
      this.setState({
        checkedPreferences: data.checkedPreferences,
        preferences: data.preferences,
      })
    );
  }

  savePreferences(formValues) {
    return actions.savePreferences(formValues).then(response => {
      FlashMessageActions.flashSuccess({ message: 'Preferences Saved!' });
    });
  }

  render() {
    return (
      <FormifiedPresentationComponent
        form="notificationPreferences"
        onSubmit={this.savePreferences}
        initialValues={
          this.state.checkedPreferences
            ? { checkedPreferences: this.state.checkedPreferences }
            : null
        }
        {...this.state}
      />
    );
  }
}

const PresentationComponent = props => {
  if (!props.preferences) return <LoadingContent />;
  return (
    <HForm onSubmit={props.handleSubmit}>
      <Errors errors={props.error || []} />
      <CheckboxGroupField
        label="Please specify your preferences"
        name="checkedPreferences"
        options={props.preferences}
      />
      <div className="form-actions">
        <SpinnerButton type="submit" className="btn btn-primary" loading={props.submitting}>
          Save Preferences
        </SpinnerButton>
      </div>
    </HForm>
  );
};

const FormifiedPresentationComponent = reduxForm({})(PresentationComponent);

export default NotificationPreferences;
